﻿import { App, Router, Util, View } from './app.js'
import { i18n, currentUser, clearValidity, elementToggle, formTrackValidity, getPasswordErrors, getCookie, getNetworkFromCreditCardNumber, hasRole, hasAdministrativeRole, modelLoading, parseBool, setActionStateMessageForTargets } from '../helper.js'
/*
 * EVENT REGISTRY
 * Primarily for UI updates that should occur when specific actions fire
 */

// Stop click events for any disabled element
document.addEventListener('click', e => e.target.closest('[disabled]') ? e.stopPropagation() : true, true)

//#region app.ready
document.addEventListener('app.ready', async e =>
{
	View.cache('layout/footer').render()

	// Privacy Alert
	if (!parseInt(getCookie(App.Config.cookieNamePrivacyAlerted) ?? 0) && window.location.href.indexOf('cookies-disabled') === -1)
		App.Modal.PrivacyPolicy.open()

	// Tooltips
	if (typeof $.fn.tooltip === 'function')
		$('[data-toggle="tooltip"]').tooltip()

	if (hasRole('Registered') && typeof $.sessionTimeout === 'function')
	{
		const store = App.Store.model('store', App.Config.storeId)
		$.sessionTimeout(
		{
			keepAliveButton: 'Stay Connected',
			keepAliveUrl: '/apex/keepalive',
			logoutUrl: '/logout',
			redirUrl: '/logout',
			warnAfter: (1000 * (store.attributes.authTimeout - 30)),
			redirAfter: (1000 * (store.attributes.authTimeout - 15)),
			countdownBar: true,
			keepAlive: false,
			ignoreUserActivity: true
		})
	}
})
//#endregion app.ready

//#region action.before
document.addEventListener('action.before', e =>
{
	switch (e.detail.name)
	{
		case 'address create':
		case 'address update':
			//#region Handle Temporary Addresses
			const newAddressGuid = '00000000-0000-0000-ADDR-000000000NEW'
			if ((!e.detail.data.id || e.detail.data.id == newAddressGuid) && e.detail.data.temporary)
			{
				e.preventDefault()

				// Add address to App.Store
				const data =
				{
					id: newAddressGuid,
					type: 'address',
					attributes: e.detail.data.attributes
				}
				data.attributes.temporary = true
				e.detail.data.id = data.id
				e.detail.model.sync(data)
				App.Store.modelCreate('address', data.id).sync(data)

				// Close the model (if open)
				App.Modal.Address.close()
			}

			// Auto-select new address
			document.querySelectorAll('[ui-component="dropdownInput"][data-type="address"]')
				.forEach(c => c.uiComponent?.dropdownInput?.select(e.detail.data.id))
			//#endregion Handle Temporary Addresses
			break;
		case 'auth update':
			if (e.detail.data.id !== 'passwordrecovery/confirm')
				break
			const authPasswordErrors = getPasswordErrors(e.detail.data.password, e.detail.data.confirmPassword)
			const authPasswordRequirementsView = App.View.cache('partial/passwordRequirements') || new View('partial/passwordRequirements')
			authPasswordRequirementsView.model.errors = authPasswordErrors
			if (authPasswordErrors.length)
				e.preventDefault()
			break
		case 'cartitem fetch':
			if (parseInt(e.detail.data.dirty) == 1)
			{
				App.Store.urlCacheClear('cartitem')
				document.getElementById('cart-nav').setAttribute('dirty', '0')
			}
			break;
		case 'invoice fetch':
			const invoiceNumber = Util.formToObject(Util.form(e.target)).invoiceNumber
			if (invoiceNumber)
			{
				e.preventDefault()
				setTimeout(() => e.target.classList.add(App.cssClass.loading))
				App.Store.fetch(`invoice/${invoiceNumber}/detail`)
					.then(invoice => Router.navigate(Handlebars.helpers.route('plugin.apex.ui.account.invoicedetail', invoice.id)))
					.catch(() =>
					{
						e.target.classList.remove(App.cssClass.loading)
						App.UI.AlertError(i18n('apex.ui.account.invoicedetail.notfound'))
					})
			}
			break
		case 'invoice pay selected':
			e.preventDefault()
			const data = Util.formToObject(Util.form(e.target))
			const total = data.invoices ? Object.values(data.invoices).reduce((prev, cur) => parseFloat(prev) + parseFloat(cur), 0).toFixed(2) : 0.00
			const filterForm = e.target.closest('.col-sm-4').querySelector('[ui-action="store page filter"]')
			const from = filterForm['filter[from]'].value
			const to = filterForm['filter[to]'].value
			const unpaidOnly = filterForm['include[unpaid]'].checked
			Router.navigate(Handlebars.helpers.route('plugin.apex.ui.account.invoicepayment'), { invoices: Object.keys(data.invoices), total, from, to, unpaidOnly })
			break
		case 'invoice update':
			const invoicePayment = Util.formToObject(Util.form(e.target))
			if (!invoicePayment.walletCardId)
			{
				const expDate = new Date(invoicePayment.creditCard.expYear, invoicePayment.creditCard.expMonth)
				if (expDate <= new Date())
				{
					e.preventDefault()
					e.target.querySelector('[name="creditCard[expMonth]"]').classList.add(App.cssClass.invalid)
					e.target.querySelector('[name="creditCard[expYear]"]').classList.add(App.cssClass.invalid)
				}
			}
			break
		case 'order fetch':
			const orderNumber = Util.formToObject(Util.form(e.target)).orderNumber
			if (orderNumber)
			{
				e.preventDefault()
				setTimeout(() => e.target.classList.add(App.cssClass.loading))
				App.Store.fetch('order', orderNumber)
					.then(order => Router.navigate(Handlebars.helpers.route('plugin.apex.ui.orderdetails', order.id)))
					.catch(err =>
					{
						e.target.classList.remove(App.cssClass.loading)
						App.Component.HandleErrors(err)
						//App.UI.AlertError(i18n('apex.ui.account.order.notfound'))
					})
			}
			break
		case 'register create':
			if (e.detail.data.id === 'practitioner')
				break
			if (e.detail.data.email !== e.detail.data.confirmEmail)
			{
				e.target.confirmEmail.setCustomValidity(i18n('account.register.emaildoesnotmatch'))
				e.target.confirmEmail.reportValidity()
				e.preventDefault()
				e.target.email.addEventListener('input', () => clearValidity(e.target.confirmEmail))
				break
			}
			const registerPasswordErrors = getPasswordErrors(e.detail.data.password, e.detail.data.confirmPassword)
			const registerPasswordRequirementsView = App.View.cache('partial/passwordRequirements') || new View('partial/passwordRequirements')
			registerPasswordRequirementsView.model.errors = registerPasswordErrors
			if (registerPasswordErrors.length)
				e.preventDefault()
			break
		case 'walletcard create':
		case 'walletcard update':
			//#region Handle Temporary Wallet Cards
			const newCardGuid = '00000000-0000-0000-CARD-000000000NEW'
			if ((!e.detail.data.id || e.detail.data.id == newCardGuid) && e.detail.data.temporary)
			{
				e.preventDefault()

				// Add addressremote to App.Store
				const dataAddress = {
					id: newCardGuid,
					type: 'addressremote',
					attributes: e.detail.data.attributes.address
				}
				App.Store.modelCreate('addressremote', dataAddress.id).sync(dataAddress)

				// Add walletcard to App.Store
				const dataCard =
				{
					id: newCardGuid,
					type: 'walletcard',
					attributes: e.detail.data.attributes,
					relationships: { address: { data: { id: dataAddress.id, type: dataAddress.type } } }
				}
				dataCard.attributes.temporary = true
				dataCard.attributes.network = getNetworkFromCreditCardNumber(dataCard.attributes.number)
				dataCard.attributes.lastFour = dataCard.attributes.number.substr(-4)
				dataCard.attributes.maskedNumber = 'X'.repeat(dataCard.attributes.number.length - 4) + dataCard.attributes.lastFour
				delete dataCard.attributes.address
				e.detail.data.id = dataCard.id
				e.detail.model.sync(dataCard)
				App.Store.modelCreate('walletcard', dataCard.id).sync(dataCard)

				// Close the model (if open)
				App.Modal.WalletCard.close()
			}

			// Auto-select new card
			const paymentMethod = hasRole('Patient') ? 'Payments.Stripe' : 'Payments.Payfabric'
			document.querySelectorAll('[ui-component="dropdownInput"][data-type="paymentmethod"]')
				.forEach(c => c.uiComponent?.dropdownInput?.select(paymentMethod + '|' + e.detail.data.id))
			//#endregion Handle Temporary Wallet Cards
			break
		case 'storestep update':
			if (e.target.attributes['ui-check-hcp'])
				e.detail.data.code.simulate = true			
			break
	}
})
//#endregion action.before

//#region action.after
document.addEventListener('action.after', async e =>
{
	if (e.detail.canceled)
		return

	switch (e.detail.name)
	{
		case 'address create':
		case 'address update':
			if (e.detail.success && parseBool(e.detail.model?.attributes?.isDefault))
				Handlebars.helpers.filterByProperty('address', 'isDefault', true).forEach(a =>
				{
					if (a.id != e.detail.data.id)
						a.attributes.isDefault = false
				})
			break
		case 'auth create':
			if (!e.detail.success)
				break

			let storeId = App.Config.storeId
			const customerId = e.detail.model?.relationships?.customer?.data?.id;
			if (customerId)
			{
				const customer = App.Store.model('customer')[customerId]
				storeId = customer?.relationships?.store?.data?.id;
			}

			if (Handlebars.helpers.isApexStore() && storeId != App.Config.storeId)
			{
				const store = App.Store.model('store')[storeId]
				const url = new URL(store.attributes.url)
				const apexLoginForm = document.querySelector('[ui-action="auth create"]')
				const pecomLoginForm = document.createElement('form')
				const pecomInput = document.createElement('input')

				pecomLoginForm.innerHTML = apexLoginForm.innerHTML
				pecomLoginForm.style.display = 'none'
				pecomLoginForm.setAttribute('action', `${url.origin}${location.pathname}`)
				pecomLoginForm.setAttribute('method', 'POST')

				pecomLoginForm.Username.value = apexLoginForm.Username.value
				pecomLoginForm.Password.value = apexLoginForm.Password.value
				pecomLoginForm.Remember[1].checked = apexLoginForm.Remember[1].checked

				pecomInput.setAttribute('type', 'hidden')
				pecomInput.name = 'PecomLogin'
				pecomInput.value = 'true'

				pecomLoginForm.append(pecomInput)
				document.body.append(pecomLoginForm)
				pecomLoginForm.submit()
			}
			else if (location.search.toLocaleLowerCase().indexOf('returnurl') > -1)
			{
				const urlParams = new URLSearchParams(location.search.toLocaleLowerCase())
				location.href = urlParams.get('returnurl')
			}
			else
			{
				location.href = location.origin
			}
			break
		case 'auth update':
			if (e.detail.data.id !== 'passwordrecovery/confirm')
				break
			if (e.detail.success)
			{
				document.querySelector('[ui-view="partial/passwordRequirements"]').classList.add('hidden')
				document.querySelector('[ui-pw-strength-meter]').classList.add('hidden')
			}
			else
				e.target.classList.remove('fail')
			break
		case 'account invoicepayment select card':
			e.target.classList.remove('success')
			const newCardEl = Util.form(e.target).querySelector('[ui-newcard]')
			if (!e.target.value)
				elementToggle(newCardEl, true)
			else
				elementToggle(newCardEl, false)
			break
		case 'account invoice toggle':
			e.target.classList.remove('success')
			const form = Util.form(e.target)
			if (e.target.name === 'all')
				form.querySelectorAll('[ui-action="account invoice toggle"]')
					.forEach(el => el === e.target ? null : el.checked = e.target.checked)
			const data = Util.formToObject(form)
			const invoices = data.invoices ? Object.entries(data.invoices).map(inv => ({ number: inv[0], balanceDue: inv[1] })) : []
			const total = data.invoices ? Object.values(data.invoices).reduce((prev, cur) => parseFloat(prev) + parseFloat(cur)) : 0
			const view = App.View.cache('account/invoicePaymentSummary')
			view.model.sync({ total, invoices })
			break
		case 'savedcart create':
			document
				.querySelectorAll('form[ui-action="savedcart create"]')
				.forEach(f => f.reset())
			break
		case 'walletcard delete':
			// We may have deleted the primary card, reload all of them
			if (e.detail.model.data && e.detail.model.data.id) // If the action was canceled the model will not have data
				App.Store.fetch('walletcard', 0)
			break
		case 'invoice update':
			if (e.detail.success)
				Router.navigate(Handlebars.helpers.route('plugin.apex.ui.account.invoicepaymentconfirmation'), JSON.parse(JSON.stringify(e.detail.model)))
			break
		case 'register create':
			if (e.detail.data.id === 'practitioner')
				break
			if (!e.detail.success)
			{
				e.target.classList.remove(App.cssClass.fail)
				break
			}
			const userRegistrationType = e.detail.model.attributes.userRegistrationType.toLocaleLowerCase()
			if (userRegistrationType === 'standard')
				location.href = location.origin
			else
				e.target.setAttribute('ui-message-success', i18n('account.register.result.' + userRegistrationType))
			break
		case 'order create':
			if (e.detail.success)
			{
				App.Store.urlCacheClear('cartitem')
				App.Store.model('cartitem').clear()
				App.Store.model('checkout').clear()
				App.Router.navigate('/checkout/completed/' + (e.detail?.model?.id || 0))
			}
			break;
		case 'storestep update':
			if (e.detail.data.code?.simulate)
			{
				e.preventDefault()
				setActionStateMessageForTargets(
					'storestep update simulate',
					e.detail.success ? i18n('apex.ui.store.setup.code.valid') : e.detail.model.errors[0].meta.errors[0],
					e.detail.success ? 'success' : 'fail',
					e.target
				)
				break
			}

			if (!e.detail.success)
				break

			//#region Show in-line success messages
			let i18nSuccessMessage = ''
			switch (e.detail.data.name)
			{
				case 'Practice':
					i18nSuccessMessage = 'apex.ui.store.setup.practice.settingssaved'
					break
				case 'Finished':
					i18nSuccessMessage = 'apex.ui.store.setup.complete.avalara.licensekey.update.success'
					break
			}

			if (i18nSuccessMessage)
				setActionStateMessageForTargets('storestep update', i18n(i18nSuccessMessage), 'success');
			//#endregion Show in-line success messages

			document.getElementById('storeSetupTitle').scrollIntoView()

			if (e.detail.model.attributes.complete &&
				// checking tagName === form because sometimes e.target is document when validating hcp code
				e.target.tagName?.toLowerCase() === 'form' &&
				e.detail.data.nextStep)
			{
				const stepsIncomplete = Object.values(App.Store.model('storestep'))
					.filter(s =>
						s.attributes.complete == false
						&& (e.detail.model?.attributes?.complete == true && s.id != e.detail.model.id)
						&& s.attributes.name != 'Start'
						&& s.attributes.name != 'Finished'
					)

				if (stepsIncomplete.length == 0)
				{
					// No incomplete steps left
					currentUser().attributes.pecomStoreSetupFinished = true
					App.Router.navigate('/store/account')
				}
				else
				{
					App.Action.cache('store page')
						.run(document.querySelector('form[ui-action="storestep update"] input[type=submit]'), { type: 'storestep', endpoint: e.detail.data.nextStep })
						.then(storestepPage =>
						{
							if (e.detail.data.stripe?.authCode)
								delete App.Store.model('storestep', e.detail.data.id).attributes.stripe?.authCode

							if (storestepPage.name === 'Code' &&
								!(App.Store.model('customer', App.Config.customerId).attributes.pecomStoreSetupFinished))
								App.Store.fetch('customer', 'current')
						})
				}
			}

			break
	}
})
//#endregion action.after

document.addEventListener('store.before', e =>
{
	//#region Quick Order
	// Ensure all cartitem requests include all and sort by id descending
	if (e.detail.type == 'cartitem')
		Util.deepAssign(e.detail.query, { include: '*', sort: '-id' })
	//#endregion Quick Order
})

document.addEventListener('store.after', e =>
{
	if (!e.detail.success)
		return

	//#region Quick Order
	// Ensure all cartitem requests include all and sort by id descending
	if (e.detail.type == 'cartitem'
		&& e.detail.fetch?.method == 'PATCH'
		&& e.detail.json?.data?.relationships?.promotionItem
		&& e.detail.json?.included)
	{
		const type = e.detail.json.data.relationships.promotionItem.data.type
		const id = e.detail.json.data.relationships.promotionItem.data.id
		for (let i in e.detail.json?.included)
		{
			if (e.detail.json?.included[i].type == type && e.detail.json?.included[i].id == id && e.detail.json?.included[i].attributes.quantity == 0)
			{
				delete e.detail.json?.included[i]
				delete App.Store.model(type)[id]
			}
		}
	}
	//#endregion Quick Order

	//#region Validate Address
	if (e.detail.type == 'address' && (e.detail.fetch?.method == 'POST' || e.detail.fetch?.method == 'PATCH'))
	{
		const validate = e.detail.json?.data?.attributes?.validate
		const valid = e.detail.json?.data?.attributes?.validation?.valid

		if (validate && !valid)
		{
			App.Modal.AddressSuggestions.open(false, false, e.detail.json.data)
			// Don't sync this data
			e.preventDefault()
			e.detail.canceled = true
			e.detail.json.data = null;
		}
	}
	//#endregion Validate Address

	//#region Checkout
	if (e.detail.type == 'checkout')
	{
		// NOP-562 The checkout endpoint includes the cart/cartitems and will add/remove StateProvince RequiredProductSku
		App.Store.model('cart').clear()
		App.Store.model('cartitem').clear()
		// Clear coupon code in case it has been removed
		const userId = currentUser().id
		if (e.detail.model.hasOwnProperty(userId) && e.detail.model[userId].attributes?.couponCode)
			delete e.detail.model[userId].attributes.couponCode
	}
	//#endregion Checkout
})

//#region view.render
let viewsPending = []
document.addEventListener('i18n.ready', function (e)
{
	for (const i in viewsPending)
	{
		viewsPending[i].render()
	}

	viewsPending = []
})

document.addEventListener('view.render.before', function (e)
{
	if (!App.ReadyI18n)
	{
		e.preventDefault()
		viewsPending.push(e.detail.view)
		return
	}
})

document.addEventListener('view.render', function(e)
{
	//#region Initialize component elements
	e.target.querySelectorAll('[ui-component]')
		.forEach(el =>
		{
			try
			{
				new App.Component[el.attributes['ui-component'].value](el)
			}
			catch
			{
				console.warn('Missing component', el.attributes['ui-component']?.value)
			}
		})
	//#endregion Initialize component elements

	if (!modelLoading(e.detail.view.model))
		e.target.classList.remove(App.cssClass.loading)

	if (e.detail.view.name == 'cart/form')
	{
		// Hack for overflow-y hidden when overflow-x is auto
		let el = e.target.querySelector('section.cart')
		el.style.minHeight = (el.scrollHeight + 1) + 'px'
	}

	if (e.detail.view.name == 'layout/topBanner')
	{
		let cssClass = Handlebars.helpers.isPecomStore() ? 'hcp-public' : 'public'
		if (hasAdministrativeRole())
		{
			const store = App.Store.model('store', App.Config.storeId)
			cssClass = store?.attributes?.environment?.toLowerCase()
		}
		document.getElementById('topBanner').className = cssClass
	}

	const fromDate = e.target.querySelector('input[type="date"][ui-date-from]')
	const toDate = e.target.querySelector('input[type="date"][ui-date-to]')
	const onDateInput = el =>
	{
		clearValidity(toDate)
		clearValidity(fromDate)

		if (!el.attributes['ui-range-limit'])
			return

		const daysDiff = Math.abs(moment(toDate.value).diff(fromDate.value, 'days'))
		const rangeLimit = parseInt(el.attributes['ui-range-limit'].value)

		if (daysDiff < rangeLimit)
			return
		if (el === fromDate)
			toDate.value = Handlebars.helpers.formatDate(fromDate.value, 'yyyy-MM-DD', rangeLimit)
		if (el === toDate)
			fromDate.value = Handlebars.helpers.formatDate(toDate.value, 'yyyy-MM-DD', rangeLimit * -1)
	}

	if (fromDate && toDate)
	{
		fromDate.oninput = e =>
		{
			toDate.min = e.target.value
			onDateInput(fromDate)
		}
		toDate.oninput = e =>
		{
			fromDate.max = e.target.value
			onDateInput(toDate)
		}
	}

	e.target.querySelectorAll('[ui-trackvalidity]').forEach(el => formTrackValidity(el))

	const autoSubmitBtn = e.target.querySelector('input[type="submit"][ui-submitonrender]')
	if (autoSubmitBtn)
		autoSubmitBtn.click()

	const toggleEl = e.target.querySelector('[ui-toggle]')
	if (toggleEl)
		elementToggle(toggleEl, toggleEl.attributes['ui-toggle'].value === 'true')

	if (typeof $.fn.tooltip === 'function')
		$('[data-toggle="tooltip"]', e.target).tooltip()

	const pwStrengthMeter = e.target.querySelector('[ui-pw-strength-meter]')
	const newPassword = e.target.querySelector('[ui-new-password]')
	if (pwStrengthMeter && newPassword)
	{
		const strengthBar = pwStrengthMeter.querySelector('.password-strength-meter')
		const strengthBarSpan = strengthBar.querySelector('span')
		$('[ui-password-input]', newPassword).pwstrength({
			ui: {
				showProgressBar: false,
				showVerdicts: false
			},
			common: {
				onScore: (options, word, score) =>
				{
					let strength = 0
					let color = 'danger'
					for (let i = 0; i < 5; i++)
					{
						if (score >= options.ui.scores[i])
							strength += 20
					}
					if (strength > 20)
						color = 'warning'
					if (strength > 80)
						color = 'success'
					strengthBar.classList.remove('progress-bar-success', 'progress-bar-warning', 'progress-bar-danger')
					strengthBar.classList.add(`progress-bar-${color}`)
					strengthBar.style.width = `${strength}%`
					strengthBar.setAttribute('aria-valuenow', strength)
					strengthBarSpan.innerText = `${strength}%`
					return score
				}
			}
		})
	}

	const recaptchaForm = e.target.querySelector('form[ui-recaptcha]')
	if (recaptchaForm)
	{
		App.Store.fetch('recaptchasettings', 0)
			.then(data =>
			{
				const attributes = data.attributes

				if (document.querySelector('script[ui-recaptcha-script]'))
					return
				if (!attributes[recaptchaForm.attributes['ui-recaptcha'].value])
					return 

				const script = document.createElement('script');
				script.src = 'https://www.google.com/recaptcha/api.js?render=' + attributes.publicKey;
				script.type = 'text/javascript';
				script.setAttribute('ui-recaptcha-script', '')
				script.onload = function ()
				{
					const gRecaptchaResponseInput = document.createElement('input')
					gRecaptchaResponseInput.type = 'hidden'
					gRecaptchaResponseInput.name = 'g-recaptcha-response'
					recaptchaForm.append(gRecaptchaResponseInput)
					recaptchaForm.onsubmit = e =>
					{
						const recaptchaInput = e.target.querySelector('input[name="g-recaptcha-response"]')
						if (recaptchaInput.value)
							return true
						e.preventDefault()
						e.stopPropagation()
						grecaptcha.ready(function ()
						{
							grecaptcha.execute(attributes.publicKey, { action: 'submit' }).then(function (token)
							{
								recaptchaInput.value = token
								e.target.querySelector('[type="submit"]').click()
							});
						});
					}
				};
				recaptchaForm.parentElement.appendChild(script);
			})
			.catch(err => { console.error(err) })
	}
})
//#endregion view.render

document.addEventListener('change', e =>
{
	//#region Quick Order
	// Changes to Quantity/ScheduleDays will submit the form
	if (e.target.form && e.target.matches('[ui-cartitem="item"] input:not([type="hidden"])') && e.target?.validity?.valid === true && e.target.value != e.target.defaultValue)
	{
		if (e.target.form.checkValidity())
			e.target.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))
		else
			e.target.form.reportValidity()
	}
	//#endregion Quick Order

	if (e.target.attributes['ui-disable-dates'])
	{
		const form = e.target.closest('form')
		const checked = e.target.checked
		Array.from(form.querySelectorAll('input[type="date"]'))
			.forEach(dateInput => dateInput.disabled = checked)
		if (checked)
			form.dataset.size = 10000
		else
			form.dataset.size = form.attributes['ui-default-page-size'].value
	}
	if (e.target.attributes['ui-disable-numbers'])
	{
		const form = e.target.closest('form')
		form.querySelectorAll('input[type="number"]').forEach(el =>
		{
			el.value = ''
			el.disabled = true
			if (el.attributes['aria-required'].value === 'true')
				el.required = false
		})
		e.target.parentElement.querySelectorAll('input[type="number"]').forEach(el =>
		{
			el.disabled = false
			if (el.attributes['aria-required'].value === 'true')
				el.required = true
		})
	}
})
